import React from 'react';
import {
    Menu,
    Search,
    Bell,
} from 'lucide-react';

interface HeaderProps {
    toggleMobileSidebar: () => void;
}

const Header: React.FC<HeaderProps> = ({ toggleMobileSidebar }) => {
    const currentDate = new Intl.DateTimeFormat('en-GB', {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
        year: 'numeric'
    }).format(new Date());

    return (
        <header className="z-20 bg-white/80 backdrop-blur-xl border-b border-gray-100 shadow-[0_2px_20px_rgba(0,0,0,0.02)] transition-all duration-300">
            <div className="h-[76px] px-6 flex items-center justify-between gap-4">

                {/* Left Side: Mobile Menu & Search */}
                <div className="flex items-center gap-4 flex-1">
                    <div className='block lg:hidden'>
                        <button
                            onClick={toggleMobileSidebar}
                            className="p-2.5 -ml-2 rounded-xl hover:bg-gray-50 text-gray-600 transition-all duration-200 active:scale-95 border border-transparent hover:border-gray-200"
                        >
                            <Menu size={22} />
                        </button>
                    </div>

                    <div className="hidden sm:flex items-center relative w-full max-w-md group">
                        <div className="absolute left-3.5 text-gray-400 group-focus-within:text-primary transition-colors">
                            <Search size={18} />
                        </div>
                        <input
                            type="text"
                            placeholder="Search employees, departments..."
                            className="w-full h-11 pl-11 pr-4 bg-gray-50/50 hover:bg-gray-50 border border-gray-200 rounded-lg text-sm outline-none focus:bg-white focus:border-primary/40 focus:ring-4 focus:ring-primary/10 transition-all duration-300 text-gray-700 placeholder:text-gray-400 shadow-sm"
                        />
                    </div>
                </div>

                {/* Right Side: Date & Actions */}
                <div className="flex items-center justify-end gap-4 sm:gap-6">
                    <button className="sm:hidden h-10 w-10 flex items-center justify-center rounded-full bg-gray-50 border border-gray-200 hover:bg-gray-100 text-gray-600 transition-colors">
                        <Search size={18} />
                    </button>

                    <div className="hidden md:flex flex-col items-end justify-center">
                        <span className="text-[10px] uppercase tracking-widest font-bold text-gray-400 mb-0.5">Today</span>
                        <div className="text-xs text-gray-700 font-medium tracking-wide">
                            {currentDate}
                        </div>
                    </div>

                    <div className="w-px h-8 bg-gray-200 hidden md:block mx-1"></div>

                    <button className="relative h-11 w-11 flex items-center justify-center rounded-full bg-gray-50 border border-gray-200 hover:bg-gray-100 hover:border-gray-300 text-gray-600 transition-all duration-200 active:scale-95 group">
                        <Bell size={19} className="group-hover:text-primary transition-colors" />
                        <span className="absolute top-2.5 right-2.5 h-2.5 w-2.5 rounded-full bg-red-500 border-2 border-white shadow-sm animate-pulse"></span>
                    </button>
                </div>
            </div>
        </header>
    );
};

export default Header;